// src/pages/Shared/Routing/ProtectedRoute.js
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, useLocation } from "react-router";

export default function ProtectedRoute() {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const { pathname } = useLocation();

  if (process.env.NODE_ENV === "development" && pathname === "/analyticspage") {
    return <Outlet />;
  }
  if (!isAuthenticated) {
    loginWithRedirect();
    return null;
  }
  return <Outlet />;
}